function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
  fill: "#bfb053"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m511.734375 267.390625-198.351563-198.355469-92.398437 92.398438 44.871094 44.867187-93.453125 93.449219 47.777344 47.777344-22.402344 22.40625-34.34375-34.34375-73.625 73.621094 91.800781 91.796874c23.542969 7.136719 48.515625 10.992188 74.390625 10.992188 137.566406 0 249.773438-108.511719 255.734375-244.609375zm0 0",
  fill: "#a59d4d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m256 422.761719h-44.710938v-89.417969h44.710938l44.710938 44.707031zm0 0",
  fill: "#8b2613"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m121.871094 333.34375h89.417968v89.417969h-89.417968zm0 0",
  fill: "#c7461f"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m390.128906 422.761719h-134.128906v-89.417969h134.128906c24.652344 0 44.710938 20.054688 44.710938 44.707031 0 24.652344-20.058594 44.710938-44.710938 44.710938zm0 0",
  fill: "#480306"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m211.289062 422.761719c-24.652343 0-44.710937-20.058594-44.710937-44.710938 0-24.652343 20.058594-44.710937 44.710937-44.710937 24.652344 0 44.710938 20.058594 44.710938 44.710937 0 24.652344-20.058594 44.710938-44.710938 44.710938zm0 0",
  fill: "#fedd90"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m211.289062 400.40625c-12.324218 0-22.355468-10.027344-22.355468-22.355469 0-12.324219 10.03125-22.355469 22.355468-22.355469 12.328126 0 22.355469 10.027344 22.355469 22.355469s-10.027343 22.355469-22.355469 22.355469zm0 0",
  fill: "#fff2a3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m121.871094 422.761719c-24.652344 0-44.710938-20.058594-44.710938-44.710938 0-24.652343 20.058594-44.710937 44.710938-44.710937s44.710937 20.058594 44.710937 44.710937c0 24.652344-20.058593 44.710938-44.710937 44.710938zm0 0",
  fill: "#fff2a3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m121.871094 400.40625c-12.324219 0-22.355469-10.027344-22.355469-22.355469 0-12.324219 10.027344-22.355469 22.355469-22.355469s22.355468 10.027344 22.355468 22.355469-10.027343 22.355469-22.355468 22.355469zm0 0",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m359.933594 150.351562c27.753906 46.46875 21.632812 107.539063-18.378906 147.550782-23.625 23.621094-54.585938 35.4375-85.554688 35.4375l-45.453125-146.050782 45.453125-146.050781s18.164062 18.167969 38.574219 38.574219c11.027343-6.363281 18.832031-10.871094 18.832031-10.871094s33.445312 58.753906 46.527344 81.410156zm0 0",
  fill: "#eb7330"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m256 333.34375c-30.96875 0-61.929688-11.820312-85.554688-35.4375-40.476562-40.476562-46.269531-102.488281-17.417968-149.136719 13.53125-23.421875 45.644531-79.96875 45.644531-79.96875s7.824219 4.519531 18.867187 10.898438c20.363282-20.363281 38.460938-38.460938 38.460938-38.460938v31.617188l-45.453125 114.433593 45.453125 123.699219zm0 0",
  fill: "#f9963b"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m221.21875 107.636719-14.238281-8.222657c-10.628907 18.679688-26.394531 46.339844-34.765625 60.828126-24.15625 39.054687-18.488282 89.332031 14.039062 121.855468 18.632813 18.628906 43.402344 28.886719 69.746094 28.886719v-238.128906zm0 0",
  fill: "#fcba66"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m302.125 177.273438c25.433594 25.433593 25.433594 66.820312 0 92.253906-12.316406 12.316406-28.703125 19.105468-46.125 19.105468l-29.804688-78.742187 29.804688-78.742187zm0 0",
  fill: "#fedd90"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m256 131.148438v157.484374c-17.421875 0-33.808594-6.789062-46.125-19.105468-25.433594-25.433594-25.433594-66.820313 0-92.253906zm0 0",
  fill: "#fff"
});

var SvgBurn = function SvgBurn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burn.f7581889.svg";
export { ForwardRef as ReactComponent };